export default "assets/contact-pin-146897e2.svg";